import type { WithStylexArray } from "@packages/ui";
import { Text } from "@packages/ui";
import type { PropsWithChildren } from "react";

type BibleNavSectionHeaderProps = PropsWithChildren<
  WithStylexArray<{ position?: number }>
>;

export const BibleNavSectionHeader = ({
  children,
  position,
  styleXArray,
}: BibleNavSectionHeaderProps) => {
  return (
    <Text
      as={"h2"}
      type={"title"}
      size={"l"}
      styleXArray={styleXArray}
      style={
        position !== undefined && position !== null
          ? { order: position }
          : undefined
      }
    >
      {children}
    </Text>
  );
};
